import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { StyledComponentProps, withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import * as React from 'react';
import { transl } from '../main/transl';

const styles = ({
});

interface IAmountToOrderDialogProps {
	value: number
	step: number
	onClose: (event: any) => void
}

@observer class _AmountToOrderDialog extends React.Component<IAmountToOrderDialogProps & StyledComponentProps> {
	render() {
		const {value, step, onClose} = this.props;
		if (!value || !step) {
			console.error('Error in AmountToOrderDialog', value, step);
			return null;
		}
		const x = value / step;
		const down = step * Math.floor(x);
		const up = step * Math.ceil(x);
		return <Dialog open={true}>
			<DialogTitle>{transl('amountStepError')}</DialogTitle>
			<DialogContent>
				<p>{transl('amountStepExplanation', step)}</p>
				<p>{transl('amountStepHint')}</p>
			</DialogContent>
			<DialogActions>
				<Button name={down + ''} onClick={onClose} color="primary">{down}</Button>
				<Button name={up + ''} onClick={onClose} color="primary">{up}</Button>
			</DialogActions>
		</Dialog>;
	}
}

export const AmountToOrderDialog = withStyles(styles)(_AmountToOrderDialog);
